// Eén bron van waarheid voor publieke content-pagina's (menu, footer, "Lees ook").
export interface SitePage { label: string; href: string }

export const mainPages: SitePage[] = [
  { label: "Hoe werkt het?", href: "/hoe-werkt-het" },
  { label: "Over De Hussel App", href: "/over-de-hussel-app" },
  { label: "Reviews", href: "/reviews" },
  { label: "Demo", href: "/demo" },
  { label: "Nieuws", href: "/nieuws" },
  { label: "Contact", href: "/contact" },
  { label: "Club registreren", href: "/club-register" },
];

export const husselPages: SitePage[] = [
  { label: "Wat is husselen?", href: "/wat-is-husselen" },
  { label: "Wat is tossen?", href: "/wat-is-tossen" },
  { label: "Husselen vs tossen vs racket trekken", href: "/husselen-vs-tossen-vs-racket-trekken" },
  { label: "Husselavond organiseren", href: "/husselavond-organiseren" },
  { label: "Tossavond organiseren", href: "/tossavond-organiseren" },
  { label: "Racket trekken organiseren", href: "/racket-trekken-organiseren" },
  { label: "Husselochtend organiseren", href: "/husselochtend-organiseren" },
  { label: "Tossochtend organiseren", href: "/tossochtend-organiseren" },
  { label: "Jeugd husselavond organiseren", href: "/jeugd-husselavond-organiseren" },
  { label: "Draaiboek husselavond", href: "/draaiboek-husselavond" },
];

export const softwarePages: SitePage[] = [
  { label: "App voor tennis hussel", href: "/tennis-hussel-app" },
  { label: "App voor tennis toss", href: "/tennis-toss-app" },
  { label: "Hussel indelingen systeem", href: "/hussel-indelingen-systeem" },
  { label: "Toss indelingen systeem", href: "/toss-indelingen-systeem" },
  { label: "AI systeem voor hussel & toss", href: "/ai-systeem-hussel-toss" },
  { label: "Spelers automatisch indelen", href: "/automatisch-indelen-tennisspelers" },
  { label: "Tennisclub software", href: "/tennisclub-software" },
  { label: "Tennisvereniging app voor spelers", href: "/tennisvereniging-app-spelers" },
];

export const blogPages: SitePage[] = [
  { label: "Meer spelers naar je husselavond", href: "/blog/meer-spelers-naar-husselavond" },
  { label: "Husselavond zonder vrijwilligers", href: "/blog/husselavond-zonder-vrijwilligers" },
];

export const allContentPages: SitePage[] = [...husselPages, ...softwarePages, ...blogPages];

/** Gerelateerde pagina's: buren binnen dezelfde groep, aangevuld met andere groep. */
export function relatedPages(currentPath: string, count = 5): SitePage[] {
  const groups = [husselPages, softwarePages, blogPages];
  const group = groups.find((g) => g.some((p) => p.href === currentPath)) ?? husselPages;
  const idx = group.findIndex((p) => p.href === currentPath);
  const rotated = idx >= 0 ? [...group.slice(idx + 1), ...group.slice(0, idx)] : group;
  const others = allContentPages.filter((p) => p.href !== currentPath && !group.includes(p));
  const offset = currentPath.length % Math.max(others.length, 1);
  const rotatedOthers = [...others.slice(offset), ...others.slice(0, offset)];
  return [...rotated.slice(0, count - 2), ...rotatedOthers].filter((p) => p.href !== currentPath).slice(0, count);
}
